import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { ExpandableText } from "web_myplann/Shared/Components/ExpandableText";
import { MultiLineText } from "web_myplann/Shared/Components/MultiLineText";
import { hasVisibleText } from "web_myplann/Shared/Utils/htmlContentUtils/hasVisibleText";

type Props = {
	label: string | null | undefined;
	text: string | null | undefined;
	maxLines?: number;
};

export const DetailNote: FC<Props> = ({ label, text, maxLines = 4 }) => {
	const theme = useTheme();

	if (!text || !hasVisibleText(text)) {
		return null;
	}

	return (
		<Stack
			direction="column"
			alignItems="left"
			gap={0.5}
			px={theme.spacingTokens.lg}
			py={theme.spacingTokens.xs}
		>
			<MultiLineText variant="body2">{label}</MultiLineText>

			<ExpandableText
				text={text}
				lines={maxLines}
				variant="bodyMedium"
				toggle="showMore"
				clampHtml={false}
			/>
		</Stack>
	);
};
